import { getFirstLetterInUppercase, getPxOrValue } from 'lib/utils/string';

// eslint-disable-next-line complexity
const getHandler = (type) => function (el, {
  value,
}) {
  if (value === false) {
    el.style.display = '';
    el.style.alignItems = '';
    el.style.justifyContent = '';
    el.style.flexDirection = '';
    el.style.flexWrap = '';
    el.style.gridGap = '';
    el.style.gridTemplateColumns = '';
    el.style.gridTemplateRows = '';

    return;
  }

  const {
    align = 'center',
    justify,
    direction,
    gap,
    columns = 1,
    rows,
    wrap,
  } = (value || {});

  const styles = {
    display: type,
    alignItems: align,
    justifyContent: justify,
    flexDirection: direction,
    flexWrap: wrap ? 'wrap' : '',
    ...(type === 'grid' ? {
      gridGap: getPxOrValue(gap),
      gridTemplateRows: typeof rows === 'number' ? `repeat(${rows}, 1fr)` : (rows || []).map((i) => (typeof i === 'number' ? `${i}fr` : i)).join(' '),
      gridTemplateColumns: typeof columns === 'number' ? `repeat(${columns}, 1fr)` : (columns || []).map((i) => (typeof i === 'number' ? `${i}fr` : i)).join(' '),
    } : {}),
  };

  Object.entries(styles).forEach(([attribute, val]) => {
    el.style[attribute] = val;
  });
};

const getAlignmentHandler = (item) => (el, {
  value: {
    self,
    items,
    content,
  } = {},
}) => {
  el.style[`${item}Content`] = content;
  el.style[`${item}Self`] = self;
  el.style[`${item}Items`] = items;
};

const getSizeHandler = (i) => (el, { value }) => {
  const val = value === undefined ? 1 : !!value;

  el.style[`flex${getFirstLetterInUppercase(i)}`] = val ? 1 : 0;
};

/**
 * Флекс или Грид
 * v-d-flex=[{align, justify, direction, wrap}] - display: flex
 * v-d-grid=[{align, justify, direction, wrap, gap, rows, columns}] - display: grid
 *
 * Выравнивание
 * v-[align|justify]=[{self, items, content}]
 *
 * Задаёт явно flex-grow или flex-shrink
 * v-[grow|shrink] = [?booleanValue]
 */
export default (Vue) => {
  ['flex', 'grid'].forEach((type) => {
    Vue.directive(`d-${type}`, {
      bind: getHandler(type),
      update: getHandler(type),
    });
  });

  ['align', 'justify'].forEach((item) => {
    Vue.directive(item, {
      bind: getAlignmentHandler(item),
      update: getAlignmentHandler(item),
    });
  });

  ['grow', 'shrink'].forEach((i) => {
    Vue.directive(i, {
      bind: getSizeHandler(i),
      update: getSizeHandler(i),
    });
  });
};
